// Runtime SPA configuration served by the gateway at /config.json (one image, every tenant).
export interface WorkspaceConfig {
  auth_mode: "auth0" | "stub";
  auth0_domain: string;
  auth0_client_id: string;
  auth0_audience: string;
  claims_namespace: string;
  api_base: string;
  report_agent_url?: string;
  /** Auth0 mode: offer the pasted-token sign-in as a small second way in (QA deployments). */
  token_signin?: boolean;
  /** Footer links on the sign-in page; a link with no target is not shown. */
  links?: { privacy?: string; support?: string };
}

let cached: WorkspaceConfig | null = null;

export async function loadConfig(url = "/config.json"): Promise<WorkspaceConfig> {
  if (cached) return cached;
  const res = await fetch(url, { cache: "no-store" });
  if (!res.ok) throw new Error(`config.json unavailable (${res.status})`);
  cached = (await res.json()) as WorkspaceConfig;
  return cached;
}

export function setConfigForTests(cfg: WorkspaceConfig) { cached = cfg; }
